import { isToday, getLocalDate } from '../../youwell-common/dateUtils';
import {
    red1, blue1, blue2, blue3, blue4, yellow1, green1, green2, orange1, green4,
} from '../../app/style/theme';
import { toLookup } from '../../youwell-common/arrayUtils';
import { findImageUrl } from '../../youwell-common/htmlUtils';
import { vimoElementGroups } from '../constants';

export const getProgram = (studentData) => {
    // this should be moved to reducer and put in viewmodel..
    if (!studentData || !studentData.programs || !studentData.programs.length > 0) {
        return null;
    }
    return studentData.programs[0];
};

export const getTrainingModules = (program) => {
    if (!program || !program.elements || program.elements.length < 1) {
        return null;
    }

    return program.elements.filter(d => d.module && d.elementGroup === vimoElementGroups.main).map(element => element.module);
};

export const getCurrentSkill = (program) => {
    if (!program || !program.elements || program.elements.length < 1) {
        return null;
    }

    const activeModules = program.elements
        .filter(d => d.startTime && getLocalDate(d.startTime) <= new Date() && (!d.endTime || getLocalDate(d.endTime) > new Date()) && d.moduleSchedule?.tasks.length > 0);

    return activeModules.length > 0 ? activeModules[0] : null;
};

export const getCurrentSkills = (program) => {
    if (!program || !program.elements || program.elements.length < 1) {
        return null;
    }

    const activeModules = program.elements
        .filter(d => d.startTime && getLocalDate(d.startTime) <= new Date() && (!d.endTime || getLocalDate(d.endTime) > new Date()) && d.moduleSchedule?.tasks.length > 0);

    return activeModules.length > 0 ? activeModules : null;
};

export const getTodaysTasks = (program) => {
    const currentSkills = getCurrentSkills(program);
    const taskLookups = currentSkills?.map(skill => toLookup(skill.module.tasks));

    const taskList = currentSkills?.reduce((prev, curr, index) => [...prev, ...curr.moduleSchedule?.tasks?.filter(d => isToday(d.date)).map(task => ({
        ...taskLookups[index][task.taskId],
        skillId: curr?.module.id,
        skillName: curr?.module.name,
    })) || []],
    []);

    return taskList;
};

export const getTaskColorByName = (taskName) => {
    if (!taskName) {
        return null;
    }
    const n = taskName.toLowerCase();

    if (n.indexOf('video') > -1) {
        return red1;
    }
    if (n.indexOf('forklar') > -1) {
        return blue4;
    }
    if (n.indexOf('oppskrift') > -1) {
        return blue1;
    }
    if (n.indexOf('bilet') > -1) {
        return green1;
    }
    if (n.indexOf('rollespel') > -1) {
        return yellow1;
    }
    if (n.indexOf('elevtrening') > -1) {
        return blue3;
    }
    if (n.indexOf('sjølvkontroll') > -1) {
        return blue2;
    }
    if (n.indexOf('hugsekort') > -1) {
        return green2;
    }
    if (n.indexOf('lego') > -1) {
        return orange1;
    }
    if (n.indexOf('visuelle teknikkar') > -1) {
        return green4;
    }

    return null;
};

export const getTaskColor = (task) => {
    if (!task || !task.name) {
        return null;
    }
    return getTaskColorByName(task.name);
};

export const getSkillDescriptionTask = (module) => {
    if (!module || !module.tasks) {
        return null;
    }

    const tasks = module.tasks.filter(d => d.name.toLowerCase().indexOf('forklaring') > -1);
    const descriptionTask = tasks.length > 0 ? tasks[0] : null;
    if (descriptionTask) {
        const imageTasks = module.tasks.filter(d => d.name.toLowerCase().indexOf('bilete') > -1);

        if (imageTasks.length > 0 && imageTasks[0].contentElements) {
            const images = imageTasks[0].contentElements.map(d => findImageUrl(`noe før..${d.htmlContent} og noe etter`)).filter(d => d);
            descriptionTask.imageUrl = images.length > 0 ? images[0] : null;
        }
    }

    return descriptionTask;
};

export const getCurrentProgramData = (studentData) => {
    const programData = getProgram(studentData);

    return {
        programData,
        currentSkills: getCurrentSkills(programData),
        todaysTasks: getTodaysTasks(programData),
    };
};
